import { COMPACT_BREAKPOINT_PX } from '../../../../constants';
import { useIsViewportNarrowerThan } from '../../../../hooks/useIsViewportNarrowerThan';

export const useIsCompact = (): boolean =>
  useIsViewportNarrowerThan(COMPACT_BREAKPOINT_PX);
